import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { useIsMounted } from 'utils/hooks/useIsMounted';
import styles from './quickNote.module.css';

export const QuickNote = ({ children }) => {
  const [isHidden, setIsHidden] = useState(true);
  const isMounted = useIsMounted();

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (isMounted()) {
        setIsHidden(false);
      }
    }, []);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [isMounted]);

  return (
    <div className={cx(styles.root, { [styles.rootHidden]: isHidden })}>
      <div className={styles.content}>
        { children }
      </div>
    </div>
  );
};

QuickNote.propTypes = {
  children: PropTypes.node.isRequired,
};
